import styles from "./CheckHistory.module.css";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";

import useAxios from "../Hooks/useAxios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import top_lock from "../../assets/images/top_lock.png";

import top_box from "../../assets/images/top_box.png";
import VisitHistoryList from "./VisitHistoryList";
import PurchaseHistoryList from "./PurchaseHistoryList";
import Loading from "../Loading/Loading";
const CheckHistory = ({ tab = 1 }) => {
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const axios = useAxios();
  const navigate = useNavigate();
  const [visitHistoryList, setVisitHistoryList] = useState([]);
  const [purchaseHistoryList, setPurchaseHistoryList] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    axios
      .get(backend_base + "/home/visit-registration/history")
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success Getting Visit History");
          console.log(res.data.visit_history_list);
          setVisitHistoryList(res.data.visit_history_list);
        } else {
          console.log("Failed");
        }
        setLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });

    axios
      .get(backend_base + "/shop/purchase/history")
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success Purchase History");
          console.log(res.data);
          const temp = res.data.map((item) => {
            const date = item.Created_at.substring(0, 10);
            const amount = item.total_bill + item.shipping_charge;
            const quantity = item.quantity;
            const id = item.id;
            return { date, quantity, amount, id };
          });
          setPurchaseHistoryList(temp.sort((a, b) => b.id - a.id));
        } else {
          console.log("Failed");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);
  const [mainPage, setMainPage] = useState(true);
  const [activeTab, setActiveTab] = useState(tab);
  return (
    <>
      <Header />
      {mainPage && (
        <div className={styles.main_div}>
          <div className={styles.header1}>履歴確認</div>
          <div className={styles.tab_section_main}>
            <div
              onClick={() => {
                setActiveTab(1);
              }}
              className={
                activeTab === 1 ? styles.tab_item_active : styles.tab_item
              }
            >
              <img className={styles.lock_icon} src={top_lock} alt="icon 1" />
              <div className={styles.tab_text_1}>購入履歴</div>
            </div>
            <div
              onClick={() => {
                setActiveTab(2);
              }}
              className={
                activeTab === 2 ? styles.tab_item_active : styles.tab_item
              }
            >
              <img className={styles.top_box} src={top_box} alt="icon 1" />
              <div className={styles.tab_text_1}>来店履歴</div>
            </div>
          </div>
          {loading && <Loading style={{ marginTop: "100px" }} />}
          {activeTab === 2 && !loading && (
            <VisitHistoryList data={visitHistoryList} />
          )}
          {activeTab === 1 && !loading && (
            <PurchaseHistoryList data={purchaseHistoryList} />
          )}
          <div
            onClick={() => {
              navigate("/top");
            }}
            className={styles.button1}
          >
            戻る
          </div>
        </div>
      )}
      <Footer />
    </>
  );
};

export default CheckHistory;
